import { cuesApi } from "../components/imports";

export const countdownReset = async (id, projectId, duration) => {
	return await cuesApi.updateCue(id, projectId, {
		state: "reset",
		endAt: Date.now() + parseInt(duration),
		pausedTimeLeft: 0,
	});
};

export const countdownSubtract = async (id, projectId, amount, shouldEnd) => {
	return await cuesApi.updateCue(id, projectId, {
		endAt: shouldEnd - parseInt(amount),
	});
};

export const countdownPause = async (id, projectId, endAt) => {
	return await cuesApi.updateCue(id, projectId, {
		state: "paused",
		pausedTimeLeft: parseInt(endAt) - Date.now(),
	});
};

export const countdownRun = async (id, projectId, pausedTimeLeft, duration) => {
	return await cuesApi.updateCue(id, projectId, {
		state: "running",
		endAt:
			pausedTimeLeft !== 0
				? Date.now() + pausedTimeLeft
				: Date.now() + parseInt(duration),
		pausedTimeLeft: 0,
	});
};
